import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './Radio.module.scss.js';
import FormField, { FormFieldPropTypes, FormFieldInputPropTypes } from '../FormField/index.js';
import { onlyWarnInDevelopmentMode, warnOnFieldProps } from '../utils/propWarnings.js';

var _excluded = ["text", "label", "className", "disabled", "input", "meta", "required", "changed", "color", "fieldProps"];
var Radio = function Radio(_ref) {
  var text = _ref.text,
    label = _ref.label,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    input = _ref.input,
    meta = _ref.meta,
    required = _ref.required,
    _ref$changed = _ref.changed,
    changed = _ref$changed === void 0 ? null : _ref$changed,
    color = _ref.color,
    fieldProps = _ref.fieldProps,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  onlyWarnInDevelopmentMode(function () {
    return warnOnFieldProps(fieldProps);
  });
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: label,
    input: input,
    required: required,
    meta: meta
  }, props, fieldProps), /*#__PURE__*/React.createElement("label", {
    className: cx(style.container)
  }, /*#__PURE__*/React.createElement("p", {
    className: style.label
  }, " ", text), /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    className: className
  }, input, {
    disabled: disabled,
    onChange: function onChange(value) {
      if (changed) {
        changed(value);
      }
      input.onChange(value);
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: style.checkmark,
    style: {
      borderColor: input.checked && color
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: style.inner,
    style: {
      backgroundColor: color
    }
  }))));
};
Radio.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  fieldProps: PropTypes.shape(FormFieldPropTypes),
  input: PropTypes.shape(FormFieldInputPropTypes),
  label: PropTypes.node,
  meta: PropTypes.object.isRequired,
  required: PropTypes.bool,
  text: PropTypes.string
};

export { Radio as default };
//# sourceMappingURL=index.js.map
